export const formatTvShowProgramName = ({
  seasonNumber,
  episodeNumber,
  episodeName,
}: {
  seasonNumber?: number | string | null
  episodeNumber?: number | string | null
  episodeName?: string | null
}) => {
  const name = episodeName ? `-${episodeName}` : ''

  return `S${seasonNumber || 1}:E${episodeNumber || 1}${name}`
}
